export { withRouter as default } from 'react-router';


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-router-dom/es/withRouter.js
// module id = 108
// module chunks = 0